export default "__VITE_ASSET__BW$4VHi8__"